import React from 'react';
import { Box } from '@mui/material';
import { Typography } from '@rentspree/component-2023.components.atoms.typography';

import { Application, DecisionType } from '../../types/application';
import { ApplicationStatusBadge } from '../atoms/ApplicationStatusBadge';

import { ApplicationCard } from './ApplicationCard';

export interface ApplicationColumnProps {
  title: string;
  applications: Application[];
  onMakeDecision: (applicationId: string, decision: DecisionType) => void;
  onCreateLease: (applicationId: string) => void;
  className?: string;
  style?: React.CSSProperties;
}

export const ApplicationColumn: React.FC<ApplicationColumnProps> = ({
  title,
  applications,
  onMakeDecision,
  onCreateLease,
  className,
  style,
}) => {
  return (
    <Box
      className={className}
      style={style}
      sx={{
        width: '100%',
        minHeight: '400px',
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: '#f9fafb',
        borderRadius: '12px',
        overflow: 'hidden',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          marginBottom: 0,
          padding: '16px 24px',
          borderRadius: '0px',
          backgroundColor: '#f9fafb',
          borderBottom: '1px solid #e5e7eb',
        }}
      >
        <Typography
          variant='h6'
          sx={{
            color: '#222222',
            fontWeight: 600,
            fontSize: '16px',
          }}
        >
          {title}
        </Typography>
        <ApplicationStatusBadge count={applications.length} />
      </Box>
      <Box
        sx={{
          paddingTop: '16px',
          paddingLeft: '16px',
          paddingRight: '16px',
        }}
      >
        {applications.map(application => (
          <ApplicationCard
            key={application.id}
            application={application}
            onMakeDecision={onMakeDecision}
            onCreateLease={onCreateLease}
          />
        ))}
      </Box>
    </Box>
  );
};
